import { IConfigSeller } from '@/models/configSeller'
import { Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Radio, RadioGroup, Textarea } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { CSSProperties, FC, useContext, useEffect, useState } from 'react'
import { MdCancel } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { PrivateRoutes } from '../../../../constants/routes'
import { IAppStore } from '../../../../models/store.model'
import { webApiService } from '../../../../services'
import { Button } from '@/components/ui/button'
import { TradeinContext } from '../context/TradeinContext'

// autoOpen: se monta ya abierto y sin su propio botón. Lo usa el listado, que dibuja el botón con los
// datos que ya tiene y monta este componente solo al hacer click, para no pedir los motivos de
// rechazo de todas las filas. En ese caso no hay provider, así que el id llega por idTradein.
const CancelTradein: FC<{ autoOpen?: boolean, idTradein?: number | string, onClosed?: () => void, onDone?: () => void }> = ({ autoOpen, idTradein, onClosed, onDone }) => {
  const [data, setData] = useState<{ open: boolean, respuesta: string, loading: boolean, otro: string, valor: string, listCR: any[] }>({ open: autoOpen === true, respuesta: '', loading: false, otro: '', valor: '', listCR: [] })
  const { id, slug } = useParams()
  const navigate = useNavigate()
  const context = useContext(TradeinContext)
  const userState = useSelector((store: IAppStore) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isWom = configSeller.config.s3.FOLDER_APP === 'ti_wom'

  const handleClose = () => {
    setData((prev) => ({ ...prev, open: false, respuesta: '', loading: false, otro: '', valor: '' }))
    if (onClosed) onClosed()
  }

  const handleSave = () => {
    setData((prev) => ({ ...prev, loading: true }))
    // Fuera de la ruta del detalle (por ejemplo en el listado) el id no viene en la url.
    webApiService.rechazarTradein({ cancel_reason: (data.respuesta === 'Otro') ? data.otro : data.respuesta, id_tradein: idTradein ?? id ?? context?.ctx.tradein.id, id_user: userState.id, client_value: data.valor, seller: slug }).then(() => {
      enqueueSnackbar('Trade-in Rechazado correctamente', { variant: 'success' })
      setData((prev) => ({ ...prev, loading: false, respuesta: '', otro: '', valor: '', open: false }))
      // Solo WOM: al rechazar se vuelve al home con el listado de trade-ins.
      if (isWom) navigate(PrivateRoutes.HOME.replace(':slug', String(slug)))
      else if (onDone) onDone()
      else if (context) context.saveCtx({ ...context.ctx, reload: true })
    }).catch((error) => {
      enqueueSnackbar('Hubo un error al rechazar', { variant: 'error' })
      setData((prev) => ({ ...prev, loading: false }))
      console.log('error ==>', error)
    })
  }

  const loadData = () => {
    setData((prev) => ({ ...prev, loading: true }))
    webApiService.getAllCR().then((res: any) => {
      setData((prev) => ({ ...prev, loading: false, listCR: [...res.data, { id: 0, name: 'Otro', type: 'Usuario' }] }))
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData((prev) => ({ ...prev, loading: false }))
    })
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      {!autoOpen && (
        <Button
          variant='destructive'
          size='sm'
          legacyColor='danger'
          legacyVariant='shadow'
          onClick={() => { setData((prev) => ({ ...prev, open: true })) }}
        >
          <MdCancel />
          Rechazar Tradein
        </Button>
      )}

      <Modal backdrop='blur' isOpen={data.open} onClose={handleClose}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>Rechazar Trade-in</ModalHeader>
          <ModalBody>
            <h4 className='text-lg mb-2 font-black'>¿Cual es el motivo de rechazo?</h4>
            <RadioGroup
              orientation='vertical'
              onChange={(e) => setData({ ...data, respuesta: e.target.value })}
            >
              {
                data.listCR.filter((e: any) => e.type.toUpperCase() === 'USUARIO').map((a:any) => {
                  return (
                    <Radio key={a.id} value={a.name} style={{ '--seller-color': `${configSeller.config.color}` } as CSSProperties} classNames={{ control: 'bg-[var(--seller-color)] border-[var(--seller-color)]', wrapper: 'group-data-[selected=true]:border-[var(--seller-color)]' }}>{a.name}</Radio>
                  )
                })
              }
            </RadioGroup>
            {
              data.respuesta === 'Otro'
                ? <Textarea
                    label='Motivo'
                    placeholder='Ingrese motivo'
                    value={data.otro}
                    rows={4}
                    fullWidth
                    onValueChange={(value) => { setData({ ...data, otro: value }) }}
                  />
                : null
            }
            <h4 className='text-lg mb-2 font-black'>¿Indicar qué monto le gustaria al cliente interesado recibir por tu equipo?</h4>
            <Input
              label='Ingrese monto'
              value={data.valor}
              fullWidth
              onValueChange={(value) => { setData({ ...data, valor: value }) }}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              variant='destructive'
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button type='submit' disabled={data.valor === '' || data.respuesta === '' || data.loading || (data.otro === '' && data.respuesta === 'Otro')} onClick={handleSave}>
              {data.loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default CancelTradein
